app-platform-tool-treaty-document-wrapper-content{height:0;flex-grow:1;display:flex}
/*# sourceMappingURL=platform-tool-treaty-document-wrapper-content.component-27F2FO5P.css.map */
